export enum PieDataTypeEnum {
    metric = 'METRIC',
    availability = 'AVAILABILITY',
    injuryType = 'INJURY_TYPE'
}